export enum ApplicationSettingCategory {
  DELIVERABLE = 'DELIVERABLE',
  SCOPE = 'SCOPE',
  GLOBAL = 'GLOBAL',
  SOW = 'SOW',
  TRAFFICKING = 'TRAFFICKING',
  DOCUSIGN = 'DOCUSIGN',
  ADOBESIGN = 'ADOBESIGN',
  CACHING = 'CACHING',
  COMPANY = 'COMPANY',
  LOGIN = 'LOGIN',
}

export const ApplicationSettingCategoryName = {
  [ApplicationSettingCategory.DELIVERABLE]: '{LANG:deliverable}',
  [ApplicationSettingCategory.SCOPE]: '{LANG:scope}',
  [ApplicationSettingCategory.GLOBAL]: 'GLOBAL',
  [ApplicationSettingCategory.SOW]: '{LANG:sow}',
  [ApplicationSettingCategory.TRAFFICKING]: 'TRAFFICKING',
  [ApplicationSettingCategory.DOCUSIGN]: 'DOCUSIGN',
  [ApplicationSettingCategory.ADOBESIGN]: 'ADOBESIGN',
  [ApplicationSettingCategory.CACHING]: 'CACHING',
  [ApplicationSettingCategory.COMPANY]: 'COMPANY',
  [ApplicationSettingCategory.LOGIN]: 'LOGIN',
}

export const ApplicationSettingCategoryOrder = [
  ApplicationSettingCategory.SCOPE,
  ApplicationSettingCategory.DELIVERABLE,
  ApplicationSettingCategory.DOCUSIGN,
  ApplicationSettingCategory.TRAFFICKING,
  ApplicationSettingCategory.LOGIN,
  ApplicationSettingCategory.ADOBESIGN,
  ApplicationSettingCategory.SOW,
  ApplicationSettingCategory.COMPANY,
]
